module.exports = __webpack_public_path__ + "static/media/down-arrow-brown.c20f7b76.svg";